import { HANDLE_SCROLL, HANDLE_SIDEBAR } from "../types/main.types";

export const handleScroll = (scrolled) => (dispatch) => {
	dispatch({
		type: HANDLE_SCROLL,
		payload: {
			scrolled: scrolled,
		},
	});
};

export const handleSidebar = (openSidebar) => (dispatch) => {
	dispatch({
		type: HANDLE_SIDEBAR,
		payload: {
			openSidebar: openSidebar,
		},
	});
};
